package com.schoolconnect.app.util

private val mobileRegex = "^[6789]\\d{9}$".toRegex()
private val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]+$".toRegex()

fun isValidMobileNumber(mobileNumber: String): Boolean {
    if (mobileNumber.length != 10) return false
    if (!mobileRegex.matches(mobileNumber)) return false
    if (mobileNumber.all { it == mobileNumber.first() }) return false
    return mobileNumber != "1234567890" && mobileNumber != "9876543210"
}

fun isValidOtp(otp: String): Boolean =
    otp.length == 6 && otp.all(Char::isDigit)

fun isValidEmail(email: String): Boolean =
    emailRegex.matches(email.trim())
